// TODO: Fix this so linter and prettier match
/* eslint-disable react/jsx-curly-newline */

/**
 * Wrapper around the normal Route component that will check to see if
 * user has permissions to the resource specified before routing to
 * that page.  If not will send them back to site root.
 *
 * Requires that rource (descriptor string) be based in and optionally
 * the level of rights required (defaults to READ)
 */
import { RIGHTS } from '../../constants/permissions'
import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'

const PrivateRoute = ({
  component: Component,
  routeComponent: RouteComponent = Route,
  permissions,
  resource,
  right = RIGHTS.READ,
  ...rest
}) => {
  const redirect = () => {
    if (typeof window !== 'undefined' && window.location) {
      window.location = '/'
    }
    return null
  }

  return (
    <RouteComponent
      {...rest}
      render={props =>
        permissions.hasAccess(resource, right) ? (
          <Component {...props} />
        ) : (
          redirect()
        )
      }
    />
  )
}

PrivateRoute.propTypes = {
  component: PropTypes.any.isRequired,
  permissions: PropTypes.object.isRequired,
  resource: PropTypes.string.isRequired,
  right: PropTypes.string,

  /**
   * NOTE: We support this so projects can optionally choose to use a different version of react-router dom before we
   * migrate all other projects. Be aware that if you choose to do this, you'll still be bringing both dependencies
   * along -- that's the cost of not keeping everyone on the same versions through shared paths.
   */
  routeComponent: PropTypes.elementType,
}

export default PrivateRoute
